module.exports = __webpack_public_path__ + "media/images/icons/party-43659c9abe7fd6f0d24a4903bf317957.svg";